import {createTrackingContext} from "./index";
import {FacebookPixelType, GoogleAdsType, TiktokPixelType} from "./types";

const facebookPixelContext: FacebookPixelType = {
	active: false,
	code: "",
	eventCheckout: false,
	eventInitiateCheckout: false,
	eventAddToCart: false,
	eventAddPaymentInfo: false,
	eventLead: false,
};

const googleAdsContext: GoogleAdsType = {
	active: false,
	conversionId: "",
	conversionLabel: "",
	name: "",
};

const tiktokPixelContext: TiktokPixelType = {
	active: false,
	code: "",
	eventAddToCart: false,
	eventInitiateCheckout: false,
	eventAddPaymentInfo: false,
	eventCompleteRegistration: false,
	eventPurchase: false,
};

export const { Context: FacebookPixelContext, Provider: FacebookPixelContextProvider } =
	createTrackingContext(facebookPixelContext);

export const { Context: GoogleAdsContext, Provider: GoogleAdsContextProvider } =
	createTrackingContext(googleAdsContext);

export const { Context: TiktokPixelContext, Provider: TiktokPixelContextProvider } =
	createTrackingContext(tiktokPixelContext);
